import Box from '@mui/material/Box'

import type { FilterOption, GroupedFilterOption } from '@models/Filter'
import { bijlageStatusTranslations } from '@util/hoofdleiding-util'

import { WerklijstTile } from '../../../aansluiting/dashboard/components/werklijsten/WerklijstTile'
import type { ProcesstapHoofdleiding } from '../../../status/types/ProcesstapHoofdleiding'
import { Grid } from '../../../theme/components/Grid'
import { initialState as initialStateAssignedBijlagen } from '../../bijlagen/services/searchAssignedBijlagen'
import { useTeBeoordelen } from '../hooks/useTeBeoordelen'
import type { Werklijst } from '../types/Werklijst'

import { TeBeoordelenFilters } from './TeBeoordelenFilters'

interface Props {
  onClickTile: (query: any, url: any) => void
  filterOptions: {
    coordinerenden: string[]
    labels: FilterOption[]
    hoofdleiding: {
      gebieden: FilterOption[]
      netbeheerders: string[]
      verantwoordelijken: GroupedFilterOption[]
      typeWerkTypes: string[]
      gemeenten: string[]
    }
    processtappen: ProcesstapHoofdleiding[]
  }
}

export const TeBeoordelen = ({ onClickTile, filterOptions }: Props) => {
  const {
    data: { reviewBijlagen },
    filters,
    initialFilters,
    onChangeFilters,
    onRefresh,
    onReset,
  } = useTeBeoordelen()

  const onClickTileBijlagen = (werklijst: Werklijst, kpiColor?: string) => {
    const { label } = werklijst

    const { opleverweekVan, opleverweekTot, ...rest } = filters

    const query = {
      filters: {
        ...initialStateAssignedBijlagen.query.filters,
        ...rest,
        documentsoort: [label],
        status: {
          code: werklijst.code,
          label: bijlageStatusTranslations[werklijst.code],
        },
        assignedTo: filters.organisatie ? [filters.organisatie] : [],
        fromWeek: opleverweekVan,
        toWeek: opleverweekTot,
        due: false,
        kpi: kpiColor,
      },
      page: initialStateAssignedBijlagen.query.page,
      sort: initialStateAssignedBijlagen.query.sort,
    }

    onClickTile(query, '/hoofdleiding/bijlagen')
  }

  return (
    <>
      <TeBeoordelenFilters
        filters={filters}
        onChange={onChangeFilters}
        initialFilters={initialFilters}
        onRefresh={onRefresh}
        onReset={onReset}
        filterOptions={filterOptions}
      />
      <Box sx={{ p: '50px' }}>
        <Grid container spacing={2}>
          {reviewBijlagen.map((werklijst) => (
            <Grid key={`${werklijst.label}-${werklijst.code}`}>
              <WerklijstTile
                werklijst={werklijst}
                onClickTile={onClickTileBijlagen}
                subLabel={bijlageStatusTranslations[werklijst.code]}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}
